import React from "react";
import SessionsToday from "../components/pages/Dashboard/SessionToday";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const SessionsTodayLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <SessionsToday />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default SessionsTodayLayout;